import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/General/InfoCard/infoCard.default"
    ).then((module) => ({
        default: module.InfoCardDefault
    }))
);
